module.exports = __webpack_public_path__ + "img/lfrm1.bc7153cc.jpg";